<template>
    <div class="data-evaluation-index">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "DataStudentEvaluationIndex",
};
</script>

<style lang="scss" scoped>
.data-evaluation-index {
    width: 100%;
    height: 100%;
}
</style>
